import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import ModalIngresar from '../components/ModalIngresar';
import HomeBanner from './HomeBanner';
import Footer from './Footer';
import {codigoPacientes} from '../codigos';
import {useSelector, useDispatch, shallowEqual} from 'react-redux';
import NavDropdown from 'react-bootstrap/NavDropdown';
import {logout, receiveValidUser, tracking} from '../store/actions/user';
import BannerHomeEducacion from './BannerHomeEducacion';
import Eventos from './Eventos';
import IconosHome from './IconosHome';
import MapaHome from './MapaHome';
import ModalValidar from './ModalValidar';
import Perfil from './Perfil';
import {Redirect} from 'react-router-dom';
import {AUTH_URL, URL} from '../store/constants';
import Button from './ButtonMenu';
import Menu from './Menu';
import Helmet from 'react-helmet';
import ReactGa from 'react-ga';
import TagManager from 'react-gtm-module';
import {setSelectedCountry} from '../store/actions/country';

const initArgs = {
  gtmId: 'GTM-K46DRV3',
};

const tagManagerArgs = {
  dataLayer: {
    page: window.location.href,
  },
  dataLayerName: 'PageDataLayer',
};

export default function Home(props) {
  const [modalShow, setModalShow] = React.useState(false);
  const [modalPerfil, setModalPerfil] = React.useState(false);

  const userState = useSelector((state) => state.user.authState, shallowEqual);
  const user = useSelector((state) => state.user.authData, shallowEqual);

  const homeClass = useSelector((state) => state.menu.homeClass, shallowEqual);
  const overlayClass = useSelector(
    (state) => state.menu.overlayClass,
    shallowEqual,
  );
  const eventos = useSelector((state) => state.events, shallowEqual);
  const homeBannerNotes = useSelector(
    (state) => state.notes.notes.filter((note) => note.show_on_home == '1'),
    shallowEqual,
  );

  const country = useSelector((state) => state.country, shallowEqual);

  const dispatch = useDispatch();
  const handleSelect = (eventKey) => {
    if (eventKey == '1') {
      dispatch(logout());
      tracking(user['user_id'], '4', '', user['name'], '');
      return <Redirect to="/" />;
    } else {
      setModalPerfil(true);
    }
  };
  let masEventos = true;

  //MODAL VALIDAR USER
  const validUser = useSelector((state) => state.user.validUser, shallowEqual);
  const [modalValidUser, setModalValidUser] = React.useState(validUser);
  const handleCloseValidUser = () => {
    setModalValidUser(false);
    dispatch(receiveValidUser(false));
  };

  const handleSelectedCountry = (e) => {
    dispatch(setSelectedCountry(e.target.id));
  };

  //Modal Cita Medica

  useEffect(() => {
    if (userState) {
      tracking(user['user_id'], '10', '', user['name'], window.location.href);
    }
    ReactGa.pageview('/');
  }, []);

  return (
    <div className={homeClass}>
      <Helmet>
        <title>Asma Zero | Información Para Pacientes</title>
        <meta name="description" content="Asma Zero" />
      </Helmet>
      <div className={overlayClass}></div>
      <header>
        <div id={props.headerClass}>
          <nav className="nav-home">
            <div className="navbar-left">
              <Link to="/" className="logo">
                {' '}
                <img
                  src={
                    window.screen.width < 500
                      ? 'img/logo-asmazero-color.png'
                      : 'img/logo-asmazero-blanco.png'
                  }
                  className="logo-blanco"></img>{' '}
                <img
                  src="img/logo-asmazero-color.png"
                  className="logo-color"></img>{' '}
              </Link>
            </div>
            <div className="container-button text-center my-auto mr-5 pr-3">
              <a
                href="https://asmazero-citas-especialista.azurewebsites.net/"
                target="_blank"
                className="btn-agendar-cita d-none">
                Agendar cita con especialista
              </a>
            </div>

            {/* {userState ? (
              <div className="navbar-right">
                <img className="icono-user" src="/img/icono-user.png" alt="" />
                <a className="enfermeria texto-azul" href="#">
                  <NavDropdown
                    onSelect={handleSelect}
                    title={user.given_name}
                    id="nav-dropdown">
                    <NavDropdown.Item eventKey="2">Perfil</NavDropdown.Item>
                    <NavDropdown.Item eventKey="1">Salir</NavDropdown.Item>
                  </NavDropdown>
                </a>
              </div>
            ) : (
                <div onClick={() => setModalShow(true)} className="navbar-right">
                  <img className="icono-user" src="/img/icono-user.png" alt="" />
                  <a className="enfermeria texto-azul" href="#">
                    {' '}
                  Ingresar{' '}
                  </a>
                </div>
              )} */}
          </nav>
        </div>
        <Menu />
      </header>
      <Button id={props.buttonTogglerId} />

      <div className="barra-redes">
        <a
          href="https://www.facebook.com/AsmaZero-Andino-104277218426999"
          target="_blank">
          <svg
            className={props.svgClass}
            xmlns="http://www.w3.org/2000/svg"
            width="23.056"
            height="23.056"
            viewBox="0 0 23.056 23.056">
            <path
              id="Icon_awesome-facebook-square"
              data-name="Icon awesome-facebook-square"
              d="M20.586,2.25H2.47A2.47,2.47,0,0,0,0,4.72V22.836a2.47,2.47,0,0,0,2.47,2.47H9.534V17.468H6.292v-3.69H9.534V10.966c0-3.2,1.9-4.965,4.821-4.965a19.643,19.643,0,0,1,2.857.249V9.389H15.6a1.845,1.845,0,0,0-2.08,1.993v2.4h3.54l-.566,3.69H13.522v7.839h7.064a2.47,2.47,0,0,0,2.47-2.47V4.72A2.47,2.47,0,0,0,20.586,2.25Z"
              transform="translate(0 -2.25)"
            />
          </svg>
        </a>

        <a href="https://www.instagram.com/asmazeroandino/" target="_blank">
          <svg
            className={props.svgClass}
            xmlns="http://www.w3.org/2000/svg"
            width="21.929"
            height="21.929"
            viewBox="0 0 21.929 21.929">
            <path
              id="Trazado_1169"
              data-name="Trazado 1169"
              d="M2.525-6.4A3.441,3.441,0,0,0,3.571-8.929a3.441,3.441,0,0,0-1.046-2.525A3.441,3.441,0,0,0,0-12.5a3.441,3.441,0,0,0-2.525,1.046A3.441,3.441,0,0,0-3.571-8.929,3.441,3.441,0,0,0-2.525-6.4,3.441,3.441,0,0,0,0-5.357,3.441,3.441,0,0,0,2.525-6.4Zm1.367-6.417A5.3,5.3,0,0,1,5.5-8.929a5.3,5.3,0,0,1-1.6,3.892A5.3,5.3,0,0,1,0-3.432a5.3,5.3,0,0,1-3.892-1.6A5.3,5.3,0,0,1-5.5-8.929a5.3,5.3,0,0,1,1.6-3.892A5.3,5.3,0,0,1,0-14.425,5.3,5.3,0,0,1,3.892-12.821Zm2.734-2.734A1.236,1.236,0,0,1,7-14.648a1.236,1.236,0,0,1-.377.907,1.236,1.236,0,0,1-.907.377,1.236,1.236,0,0,1-.907-.377,1.236,1.236,0,0,1-.377-.907,1.236,1.236,0,0,1,.377-.907,1.236,1.236,0,0,1,.907-.377A1.236,1.236,0,0,1,6.627-15.555ZM1.067-17.725,0-17.718l-1.067-.007q-.97-.007-1.472,0t-1.346.042a11.056,11.056,0,0,0-1.437.14,5.594,5.594,0,0,0-1,.258,3.619,3.619,0,0,0-1.228.809,3.619,3.619,0,0,0-.809,1.228,5.594,5.594,0,0,0-.258,1,11.056,11.056,0,0,0-.14,1.437q-.035.844-.042,1.346T-8.8-10q.007.97.007,1.067T-8.8-7.861q-.007.97,0,1.472t.042,1.346a11.056,11.056,0,0,0,.14,1.437,5.594,5.594,0,0,0,.258,1,3.619,3.619,0,0,0,.809,1.228A3.619,3.619,0,0,0-6.32-.572a5.594,5.594,0,0,0,1,.258,11.056,11.056,0,0,0,1.437.14q.844.035,1.346.042t1.472,0L0-.14l1.067.007q.97.007,1.472,0T3.885-.174a11.056,11.056,0,0,0,1.437-.14,5.594,5.594,0,0,0,1-.258,3.619,3.619,0,0,0,1.228-.809,3.619,3.619,0,0,0,.809-1.228,5.594,5.594,0,0,0,.258-1,11.055,11.055,0,0,0,.14-1.437q.035-.844.042-1.346t0-1.472q-.007-.97-.007-1.067T8.8-10q.007-.97,0-1.472t-.042-1.346a11.056,11.056,0,0,0-.14-1.437,5.594,5.594,0,0,0-.258-1,3.62,3.62,0,0,0-.809-1.228,3.619,3.619,0,0,0-1.228-.809,5.594,5.594,0,0,0-1-.258,11.056,11.056,0,0,0-1.437-.14q-.844-.035-1.346-.042T1.067-17.725Zm9.577,4.374q.07,1.228.07,4.422t-.07,4.422A6.545,6.545,0,0,1,8.915-.014a6.545,6.545,0,0,1-4.492,1.73q-1.228.07-4.422.07t-4.422-.07A6.544,6.544,0,0,1-8.915-.014a6.544,6.544,0,0,1-1.73-4.492q-.07-1.228-.07-4.422t.07-4.422a6.545,6.545,0,0,1,1.73-4.492,6.544,6.544,0,0,1,4.492-1.73q1.228-.07,4.422-.07t4.422.07a6.545,6.545,0,0,1,4.492,1.73A6.545,6.545,0,0,1,10.645-13.351Z"
              transform="translate(10.964 19.893)"
              strokeWidth="0.5"
            />
          </svg>
        </a>
      </div>

      <HomeBanner />

      {/* <IconosHome /> */}

      {/* <BannerHomeEducacion homeBannerNotes={homeBannerNotes} /> */}

      <MapaHome />

      <section style={{backgroundColor: '#f4f1ef', height: '3rem'}}></section>

      {eventos.allEvents && (
        <div>
          {user ? (
            <div>
              {eventos.allEvents.length > 0 && (
                <Eventos
                  tracking={true}
                  masEventos={masEventos}
                  eventos={eventos.allEvents.slice(0, 2)}
                />
              )}
            </div>
          ) : (
            <div>
              {eventos.disloggedEvents.length > 0 && (
                <Eventos
                  tracking={true}
                  masEventos={masEventos}
                  eventos={eventos.disloggedEvents.slice(0, 2)}
                />
              )}
            </div>
          )}
        </div>
      )}

      <Footer codigo={codigoPacientes} fondoAzul={true} />
      <ModalIngresar
        ingresar={true}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
      <Perfil show={modalPerfil} onHide={() => setModalPerfil(false)} />
      <ModalValidar show={modalValidUser} onHide={handleCloseValidUser} />
    </div>
  );
}
